import React, { useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Routes where profileless users are allowed to land — the CompleteProfileNudge
// banner renders inside these pages instead of force-redirecting.
const SOFT_PROMPT_PATHS = ['/browse', '/views', '/me', '/profile/setup', '/muted'];

const ProtectedRoute = ({ children, requireProfile = true }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const redirectState = useMemo(() => ({ from: location }), [location]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-fnl-dark">
        <div className="w-12 h-12 border-4 border-fnl-pink border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={redirectState} replace />;
  if (
    requireProfile &&
    !user.has_profile &&
    !SOFT_PROMPT_PATHS.includes(location.pathname)
  ) {
    return <Navigate to="/profile/setup" replace />;
  }
  return children;
};

export default ProtectedRoute;
